import { initVideoListener,initLazyLoad, copyTextToClipboard } from "@api/utils_2020";
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';
import('./pbds-dyncms--contents.css');

const pbdsDyncmsContents = {
    init: function() {
        initLazyLoad();
        console.log("pbds-dyncms--contents: INIT");
        // Modais
        $(".pbds-dyncms--contents").find(".jsShow").on("click", function(e) {
            $(this).closest(".pb-item--releases").toggleClass("expanded");
            return false;
        });
        // Line Carousel 
        $('.pbds-dyncms--contents.line').each(function(){ 
            var lineCarousel = new Splide($(this).find('.splide')[0] ,{
                arrows: true,
                pagination: false,
                gap: '0px',
                perPage: 3,
                perMove: 1,
                snap   : true,
                breakpoints: {
                    1533: {                        
                        perPage: 2
                    },
                    1023: {                        
                        perPage: 4
                    },
                    769: {                        
                        perPage: 2
                    }
                }
            }).mount();
        });
        setTimeout(function(){
            initVideoListener();   
        }, 1000);
        
    }
}

window.loadedComponents.push({ component: 'pbds-dyncms--contents', init: pbdsDyncmsContents.init});

export default () => {
    pbdsDyncmsContents.init();
}